// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ranking-query-index[data-v-95cd0c2c] {\n  min-width: 1200px;\n}\n", ""]);
// Exports
module.exports = exports;
